import React, {useEffect, useState} from 'react'
import { Row, Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
// import { addProtondxAdminTestPanelID, updateProtondxAdminTestPanelID, deleteProtondxAdminTestPanelID } from '../../../redux-store/actions/protondxAdminActions'
import { addTestPanelAPI, updateTestPanelAPI, deleteTestPanelAPI }  from './SampleTestAPI'

const TestPanelComponent = (props) => {

  // var {processing, success, error} = useSelector((state)=>state.protondxAdminAddTestPanelId)
  // var {processing2, success2, error2} = useSelector((state)=>state.protondxAdminUpdateTestPanelId)
  // var {processing3, success3, error3} = useSelector((state)=>state.protondxAdminDeleteTestPanelId)

  const [error, setError] = useState(false)

  const dispatch = useDispatch()

  const [testpanelid, setTestPanelId] = useState('')
  const [testpanelenabled, setTestPanelEnabled] = useState(false)
  const [id, setId] = useState(null) //DB id
  const [editmode, setEditMode] = useState(false)

  useEffect(()=>{
    if(props.testpanelid){
      setTestPanelId(props.testpanelid)
    }
    if(props.testpanelenabled){
      setTestPanelEnabled(props.testpanelenabled)
    }
    //set initial data here
    if(props.dbid){
      setId(props.dbid)
    }
  },[props])

  const addTestPanelID = async (e)=>{
      e.preventDefault()
      if(typeof(testpanelenabled) === 'undefined'){
        setTestPanelEnabled(false)
      }

      if(testpanelid){
        let success = await addTestPanelAPI(testpanelid, testpanelenabled)
        //await dispatch(addProtondxAdminTestPanelID(testpanelid, testpanelenabled))
        if(success && success.status_code == 200){
          var newobj = {}
          newobj.testpanelid = testpanelid
          if(!testpanelenabled){
            newobj.testpanelenabled = false
            setTestPanelEnabled(false)
          }else{
            newobj.testpanelenabled = testpanelenabled
          }
          // if(id !== null){
          //   newobj._id = Math.floor(Math.random()*10000) //for testing
          // }else{
          //   newobj._id = id //needs to come from db
          // }else{
            newobj._id = success.id
          //}
          props.testPanelArray.push(newobj)
          props.setNewTestPanel(true)
          setError(false)
        }else{
          setError(true)
        }
      }
  }

  const updateTestPanelID = async (e)=>{
      e.preventDefault()
      if(testpanelid && editmode === true){
          let success2 = await updateTestPanelAPI(id, testpanelid, testpanelenabled)
          //await dispatch(updateProtondxAdminTestPanelID(id, testpanelid, testpanelenabled))
          if(success2 && success2.status_code == 200){
            props.updateTPArray(id, testpanelid, testpanelenabled, true)
            setEditMode(false) //after the api call is successful
            setError(false)
          }else{
            setError(true)
          }
      }
      setEditMode(true)
  }

  const deleteTestPanelID = async (e)=>{
    e.preventDefault()
    if(testpanelid){
      let success3 = await deleteTestPanelAPI(id)
      //await dispatch(deleteProtondxAdminTestPanelID(id))
      if(success3 && success3.status_code == 200){
        props.updateTPArray(id, null, null, false)
        setError(false)
      }else{
        setError(true)
      }
    }
  }

  const editingModeInit = (value, checkbox) => {
    if(checkbox === true){
      setTestPanelEnabled(value)
    }else{
      setTestPanelId(value)
    }
    setEditMode(true)
  }

  return (
    <form>
      <Row>
          <Col sm="7">
              <input
                  autoFocus
                  type='text'
                  value={error ? "NETWORK ERROR" : testpanelid}
                  required
                  onChange={(event)=>editingModeInit(event.target.value, false)}
                  className='modal-input-box'
                  style={{width: "100%"}}
              />
          </Col>
          <Col sm="1" style={{flexDirection: "row"}}>
            { testpanelenabled ?
              <input
                  autoFocus
                  type='checkbox'
                  required
                  onChange={(event)=>setTestPanelEnabled(event.target.checked, true)}
                  checked
                  className="chkboxstyle"
              />
              :
              <input
                  autoFocus
                  type='checkbox'
                  required
                  onChange={(event)=>setTestPanelEnabled(event.target.checked, true)}
                  className="chkboxstyle"
              />
            }
            {/* sampleenabled ?
              <label className="px-2" style={{fontSize: "6pt"}}>Enabled</label>
              : <label className="px-2" style={{fontSize: "6pt"}}>Disabled</label>
            */}
          </Col>
          <Col sm="4">
          <div className="sample-operation">
              { (props && props.dbid === "") &&
                <button
                  value=""
                  onClick={(event)=>addTestPanelID(event)}
                  className="dfaddbtn">
                </button>
              }
              <button
                value=""
                onClick={(event)=>updateTestPanelID(event)}
                className={ editmode === true ? "dfsavebtn" : "dfupdatebtn"}>
              </button>
              <button
                value=""
                onClick={(event)=>deleteTestPanelID(event)}
                className="dfdeletebtn">
              </button>
          </div>
          </Col>
      </Row>
    </form>
  )
}
export default TestPanelComponent
